/**
 * @generated SignedSource<<5926e2673028e43d3bf197887fd7fc06>>
 * @relayHash b1117842594715ac212169b79eb442d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ace14734dad9021f1798d9022d653043461eb5e0d46cb8000a4e520aa0fa9879

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBatchWindowPreference = "DEFAULT_BATCHING" | "FIFTEEN_MINUTES" | "FIVE_MINUTES" | "NO_BATCHING" | "ONCE_PER_DAY" | "ONE_DAY" | "ONE_HOUR" | "TEN_MINUTES" | "THIRTY_MINUTES" | "%future added value";
export type JiraEmailMimeType = "HTML" | "TEXT" | "%future added value";
export type JiraUpdateNotificationOptionsInput = {
  batchWindow?: JiraBatchWindowPreference | null | undefined;
  dailyBatchLocalTime?: string | null | undefined;
  emailMimeType?: JiraEmailMimeType | null | undefined;
  isEmailNotificationEnabled?: boolean | null | undefined;
  notifyOwnChangesEnabled?: boolean | null | undefined;
  notifyWhenRoleAssigneeEnabled?: boolean | null | undefined;
  notifyWhenRoleReporterEnabled?: boolean | null | undefined;
};
export type assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation$variables = {
  cloudId: string;
  input: JiraUpdateNotificationOptionsInput;
};
export type assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationOptions: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly options: {
        readonly " $fragmentSpreads": FragmentRefs<"assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation = {
  response: assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation$data;
  variables: assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "notifyWhenRoleAssigneeEnabled"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ace14734dad9021f1798d9022d653043461eb5e0d46cb8000a4e520aa0fa9879",
    "metadata": {},
    "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d62f697263af97ce9f06d3b92aeacea7";

export default node;
